import { render, staticRenderFns } from "./TeachingHistory.vue?vue&type=template&id=49d973a2&scoped=true&"
import script from "./TeachingHistory.vue?vue&type=script&lang=js&"
export * from "./TeachingHistory.vue?vue&type=script&lang=js&"
import style0 from "./TeachingHistory.vue?vue&type=style&index=0&id=49d973a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d973a2",
  null
  
)

export default component.exports